import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import UserAuthContext from '../components/Context/userContext';
import LoadingContext from '../components/Context/loadingContext';

const ProtectedRoute = ({
  admin, superadmin, mahasiswa, component, path,
}) => {
  const userConsumer = useContext(UserAuthContext);
  const loadingConsumer = useContext(LoadingContext);

  const { role } = userConsumer;
  if (
    (superadmin && role === 'superadmin')
        || (admin && (role === 'admin' || role === 'superadmin'))
        || (mahasiswa && role === 'mahasiswa')
  ) {
    return (
      <Route exact path={path} component={component} />
    );
  }
  if (loadingConsumer) {
    return <></>;
  }
  return <Redirect to="/" />;
};

ProtectedRoute.defaultProps = {
  admin: false,
  superadmin: false,
  mahasiswa: false,
  component: () => (<div>Nothing</div>),
  path: '/',
};

ProtectedRoute.propTypes = {
  admin: PropTypes.bool,
  superadmin: PropTypes.bool,
  mahasiswa: PropTypes.bool,
  component: PropTypes.func,
  path: PropTypes.string,
};

export default ProtectedRoute;
